import { motion } from 'framer-motion'
import { X } from 'lucide-react'
import { ReactNode } from 'react'
import { toast } from 'sonner'

import IconAlert from '@/components/assets/icon_alert.svg'
import IconCheckRound from '@/components/assets/icon_check_round.svg'
import { Button } from '@/components/ui/button'

const toastIconMap = {
  success: IconCheckRound,
  error: IconAlert,
}

type ToastType = keyof typeof toastIconMap
type ToastParams = {
  type: ToastType
  title?: string
  message: string | ReactNode
}

export function showToast({ type, title, message }: ToastParams) {
  const Icon = toastIconMap[type]

  toast(
    <div className="flex items-center gap-4">
      <motion.div
        initial={{ width: 0, display: 'none' }}
        animate={{ width: type === 'error' ? '120px' : '0', display: 'block' }}
        transition={{ duration: 0.5 }}
        className="absolute top-0 left-0 h-full bg-[linear-gradient(90deg,_var(--feedback-red)_0%,_rgba(245,_50,_50,_0)_100%)] opacity-50"
      />
      <Icon className="z-10 size-6" />
      <div className="z-10 flex w-full items-center justify-between">
        <div className="flex flex-col">
          {title && (
            <h2 className="subheader-2 text-[18px] leading-[32px] tracking-[0.2px]">{title}</h2>
          )}
          <p className="body-2">{message}</p>
        </div>
        <Button
          size="icon"
          variant="ghost"
          className="justify-end p-0"
          onClick={() => toast.dismiss()}
        >
          <X className="stroke-vive-primary-20 size-5 transition-all hover:stroke-white" />
        </Button>
      </div>
    </div>,
    {
      position: 'bottom-center',
      className:
        'border-0 px-6 py-3 overflow-hidden min-w-[400px] [&>div]:w-full bg-vive-primary-80',
      duration: 3000,
    },
  )
}
